const editGroupModalStyles = (theme) => ({
  dialogField: {
    marginBottom: theme.spacing(2),
  },
})

export default editGroupModalStyles
